import TAO_KOE from './_TAO_KOE.js';

const getDispatchUrl = function( pathname ) {
	const current = TAO_KOE.MenuDomain || '/';
	return current.replace( /\/+$/, '' ) + pathname;
};

export default getDispatchUrl;
